import { render, staticRenderFns } from "./LanguageSelectPopup.vue?vue&type=template&id=cc08c67e&scoped=true&"
import script from "./LanguageSelectPopup.vue?vue&type=script&lang=js&"
export * from "./LanguageSelectPopup.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelectPopup.vue?vue&type=style&index=0&id=cc08c67e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc08c67e",
  null
  
)

export default component.exports